import React from "react";
import "./HomeMobile.css";
import Counter from "../updateHomeOne/Counter";
import CounterMobile from "../updateHomeOne/CounterMobile";
import { Link } from "react-router-dom";

const reviews = [
    {
      id: "1",
      name: "Md Sharif",
      uni: "Dhaka University",
      img: "https://example.com/john.jpg",
      review:
        "Tutor Find Students made it incredibly easy for me to connect with students in my area. The interface is user-friendly, and I have been able to increase my tutoring sessions significantly. Highly recommend!",
    },
    {
      id: "2",
      name: "Sabbir Islam",
      uni: "Chittagong University",
      img: "https://example.com/jane.jpg",
      review:
        "As a tutor, finding students was always a challenge until I started using this platform. The matching system is efficient, and I've had great experiences with my students so far. The support team is also very responsive.",
    },
    {
      id: "3",
      name: "Rafiq Haque",
      uni: "Brac University",
      img: "https://example.com/emily.jpg",
      review:
        "I love how easy it is to set up my profile and start receiving student inquiries. The site has a great layout and offers various tools to help me manage my tutoring schedule.",
    },
    {
      id: "4",
      name: "Touhidul Haque Uthso",
      uni: "Tongi Govt. College",
      img: "https://example.com/michael.jpg",
      review:
        "Tutor Find Students has expanded my reach beyond my local area, allowing me to offer online sessions to students nationwide. The platform is reliable and easy to use.",
    },
    {
      id: "5",
      name: "Sopnil Islam",
      uni: "Jagannath University",
      img: "https://example.com/sophia.jpg",
      review:
        "The platform is a game-changer for tutors. I've been able to connect with students who are genuinely interested in learning, and the feedback system helps me improve my tutoring skills.",
    },
    {
      id: "6",
      name: "Maruf Ahmed",
      uni: "Dhaka Medical College",
      img: "https://example.com/james.jpg",
      review:
        "Signing up for Tutor Find Students was one of the best decisions I've made. I've been able to fill my schedule with students who match my expertise perfectly. It's an essential tool for any tutor.",
    },
    {
      id: "7",
      name: "Rakib Islam",
      uni: "North South University",
      img: "https://example.com/olivia.jpg",
      review:
        "I've had a wonderful experience using this platform. The process of finding students is seamless, and the site provides all the necessary tools to ensure a successful tutoring session. I highly recommend it to fellow tutors.",
    },
  ];
  const counters = [
    {
      id: 1,
      img: "https://caretutors.com/assets/img/landing_page/total_apply.png",
      targetCount: 369500,
      label: "Active Tutors",
    },
    {
      id: 2,
      img: "https://caretutors.com/assets/img/landing_page/total_jobs.png",
      targetCount: 284700,
      label: "Live Tuition Jobs",
    },
   
  ];

const doubledReviews = [...reviews, ...reviews];
const HomeMobile = () => {
  return (
    <div className="w-full bg-gray-200 h-screen flex flex-col gap-10">
      <div className="titleShape bg-green-800 flex justify-center items-center">
        <h1 className="text-2xl font-bold text-white font-marcellus">
          Tutor Tree
        </h1>
      </div>

      <div className="w-full py-4 px-4 rounded-2xl  ">
        <div className=" bg-white rounded-2xl px-4 py-3">
          <h1 className="text-xl font-signika text500 text-center">
            Hire The Right Tutor Today
          </h1>
          <p className="text-center text-sm my-4">
            Connecting You with the Best <br></br> Tutors in Every Subject.
          </p>
          <div>
          <div className="grid grid-cols-2 gap-5 w-full py-2">
            {counters.map((counter) => (
              <div key={counter.id} className="text-center">
                <p className="text-white text-xl"></p>
                <div className="flex flex-row justify-center items-center gap-3">
                  <div className="flex flex-col justify-start items-start gap-1">
                    <CounterMobile targetCount={counter.targetCount} />

                    <h1 className="text-green-900 font-signika text-sm">
                      {counter.label}
                    </h1>
                  </div>
                </div>
              </div>
            ))}
          </div>
          </div>
          <div className="flex justify-center gap-2 items-center">
          
            <Link to="/loginMobile">
            <button className="text-sm font-signika text-white bg-green-800 rounded-full px-4 py-1 ">
              Sign In
            </button>
            </Link>
            |
            <Link to="/signupMobile">
            <button className="text-sm font-signika text-white bg-green-800 rounded-full px-4 py-1 ">
              Sign Up
            </button>
            </Link>
          </div>
          <div className="flex justify-center items-center mt-4 border-b border-green-900 pb-4">
            <Link to="/jobMobile">
            <button className="text-sm font-signika text-black bg-transparent border border-green-900 rounded-full px-6 py-1 ">
              Job Board
            </button>
            </Link>
            
   
          </div>
          {/* home tutoring start */}
          <div className="grid grid-cols-2 gap-2 mt-2">
            <div className="p-2 rounded-lg border-2 border-green-200">
              <h1 className="text-lg font-signika text-green-900">
                Home Tutoring
              </h1>
          
            </div>
            <div className="p-2 rounded-lg border-2 border-green-200">
              <h1 className="text-lg font-signika text-green-900">
                Group Tutoring
              </h1>
         
            </div>
            <div className="p-2 rounded-lg border-2 border-green-200">
              <h1 className="text-lg font-signika text-green-900">
                Online Tutoring
              </h1>
          
            </div>
            <div className="p-2 rounded-lg border-2 border-green-200">
              <h1 className="text-lg font-signika text-green-900">
                Package Tutoring
              </h1>
           
            </div>
          </div>
          {/* home tutoring end */}
          <div className="flex justify-center items-center flex-col mt-4">
        <div className="w-full flex justify-start items-center overflow-hidden">
          <div className="flex flex-row animate-slide-reverse gap-5">
            {doubledReviews.map((data, index) => (
              
              <div className="">
              <div className="containerDetails z-0 relative card bg-green-700 w-[200px] flex-shrink-0 h-28  flex justify-center items-center p-10 ">
                <img
                  alt=""
                  className="w-10 absolute bottom-5 right-3 opacity-20"
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMTk4IDE5OCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZD0iTTAgOTIuOTA1aDQ4LjAyNGMtLjgyMSAzNS0xMC43NDggMzguOTczLTIzLjIxNiA0MC4xMDdsLTQuODA4LjU5NnYzOC40ODZsNS41NDItLjI5N2MxNi4yODEtLjkxNiAzNC4yODEtMy44NTEgNDYuMjktMTguNjc2QzgyLjM1OSAxNDAuMTI1IDg3IDExOC44OTMgODcgODYuM1YyNS45MDVIMHY2N3pNMTExIDI1LjkwNXY2N2g0Ny4zODNjLS44MjEgMzUtMTAuNDI3IDM4Ljk3My0yMi44OTUgNDAuMTA3bC00LjQ4OC41OTZ2MzguNDg2bDUuMjIyLS4yOTdjMTYuMjgxLS45MTYgMzQuNDQyLTMuODUxIDQ2LjQ1MS0xOC42NzZDMTkzLjE5OSAxNDAuMTI1IDE5OCAxMTguODkzIDE5OCA4Ni4zVjI1LjkwNWgtODd6IiBmaWxsPSIjZmZmZmZmIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                />
                {/* Overlay */}
                <div className="overlay absolute top-0 left-0 w-full  bg-green-400 opacity-50"></div>

                {/* Text */}
                <div className="flex flex-col justify-between text absolute top-0 left-0 p-2 z-10 text-white w-[100%] h-[100%]">
                <div className="flex justify-between flex-col h-full gap-5">
                  <div className="">
                    <h1 className=" text-white text-md   font-signika ">
                      {data.name}
                    </h1>
                    <h1 className=" text-white font-signika mt-1 text-sm border-b border-b-green-200">
                      {data.uni}
                    </h1>
                    <h1 className="mt-2 text-red-300 break-words whitespace-normal text-start text-sm font-signika">
                    {data.review.slice(0,50)}...
                  </h1>
                  </div>
                 
                </div>
                </div>
              </div>
            </div>
            ))}
          </div>
        </div>
          </div>
        </div>
       
      </div>
    </div>
  );
};

export default HomeMobile;
